import { useState, useCallback } from 'react'
import Lightbox from '../components/Lightbox'

const GALLERIES = [
  {
    title: 'End of the Season 2014',
    description: 'ALAMAR made it successfully through another season. Here she is drying her sails before shedding them for the winter.',
    cols: 3,
    images: [
      '/assets/uploads_1_2_8_8_12888984_4096032.jpg',
      '/assets/uploads_1_2_8_8_12888984_6937500.jpg',
      '/assets/uploads_1_2_8_8_12888984_7159389.jpg',
    ],
  },
  {
    title: 'Summer Celebration 2014',
    description: "ALAMAR played commodious host to A&B's summer celebration - getting many newbies out for a little adventure and island hopping. The weather was glorious and a good time was had by all.",
    cols: 4,
    images: [
      '/assets/uploads_1_2_8_8_12888984_2307093.jpg',
      '/assets/uploads_1_2_8_8_12888984_9952310.jpg',
      '/assets/uploads_1_2_8_8_12888984_9470118.jpg',
      '/assets/uploads_1_2_8_8_12888984_5262978.jpg',
      '/assets/uploads_1_2_8_8_12888984_6267452.jpg',
      '/assets/uploads_1_2_8_8_12888984_9336354.jpg',
      '/assets/uploads_1_2_8_8_12888984_1588400.jpg',
      '/assets/uploads_1_2_8_8_12888984_4899291.jpg',
      '/assets/uploads_1_2_8_8_12888984_2185366.jpg',
      '/assets/uploads_1_2_8_8_12888984_6136313.jpg',
      '/assets/uploads_1_2_8_8_12888984_1910841.jpg',
      '/assets/uploads_1_2_8_8_12888984_1053122.jpg',
      '/assets/uploads_1_2_8_8_12888984_7531327.jpg',
      '/assets/uploads_1_2_8_8_12888984_9004496.jpg',
    ],
  },
  {
    title: 'Molnar Adventure (July 2012)',
    description: 'The family Molnar chartered ALAMAR and circumnavigated Deer Isle counter-clockwise via Vinalhaven. The crew put the ship to great use - kudos for sailing the dingy and lighting the lantern! Another great summer on the coast of Maine... until next year!',
    cols: 4,
    images: [
      '/assets/uploads_1_2_8_8_12888984_6771336.jpg',
      '/assets/uploads_1_2_8_8_12888984_269380.jpg',
      '/assets/uploads_1_2_8_8_12888984_4067230.jpg',
      '/assets/uploads_1_2_8_8_12888984_5982218.jpg',
      '/assets/uploads_1_2_8_8_12888984_8569864.jpg',
      '/assets/uploads_1_2_8_8_12888984_3038131.jpg',
      '/assets/uploads_1_2_8_8_12888984_2565613.jpg',
      '/assets/uploads_1_2_8_8_12888984_6304664.jpg',
      '/assets/uploads_1_2_8_8_12888984_1790491.jpg',
      '/assets/uploads_1_2_8_8_12888984_8493104.jpg',
      '/assets/uploads_1_2_8_8_12888984_82256.jpg',
      '/assets/uploads_1_2_8_8_12888984_6167350.jpg',
      '/assets/uploads_1_2_8_8_12888984_288867.jpg',
    ],
  },
  {
    title: "Voluntary Rides Again! Sept 2012",
    description: "Thanks to the unrivaled craftsmanship and dedication of Peter Chase (Cape Rosier Boat Shop), along with the generous support of many family, friends, and AIC alumns, the VOLUNTARY II was launched in Horseshoe Cove in mid September. A crowd was on hand with appropriate libations and she was taken for a spin by the newly married couple.",
    cols: 4,
    images: [
      '/assets/uploads_1_2_8_8_12888984_7212101.jpg',
      '/assets/uploads_1_2_8_8_12888984_5560961.jpg',
      '/assets/uploads_1_2_8_8_12888984_423216.jpg',
      '/assets/uploads_1_2_8_8_12888984_3577182.jpg',
      '/assets/uploads_1_2_8_8_12888984_9505742.jpg',
      '/assets/uploads_1_2_8_8_12888984_4028229.jpg',
      '/assets/uploads_1_2_8_8_12888984_4634823.jpg',
      '/assets/uploads_1_2_8_8_12888984_2249715.jpg',
    ],
  },
  {
    title: "Ship's Log: Summer 1965",
    description: "We have posted some ships logs from the Summer of 1965. Skipper Carl Chase and Mate Dunc Martin (with a collection of familiar campers and crew) chronicle the ALAMAR's exploits on Penobscot Bay.",
    cols: 6,
    images: [
      '/assets/uploads_1_2_8_8_12888984_4144073.jpg',
      '/assets/uploads_1_2_8_8_12888984_4314580.jpg',
      '/assets/uploads_1_2_8_8_12888984_8044247.jpg',
      '/assets/uploads_1_2_8_8_12888984_4062164.jpg',
      '/assets/uploads_1_2_8_8_12888984_4984963.jpg',
      '/assets/uploads_1_2_8_8_12888984_4808623.jpg',
      '/assets/uploads_1_2_8_8_12888984_5347871.jpg',
      '/assets/uploads_1_2_8_8_12888984_1554143.jpg',
      '/assets/uploads_1_2_8_8_12888984_6215253.jpg',
      '/assets/uploads_1_2_8_8_12888984_3874139.jpg',
      '/assets/uploads_1_2_8_8_12888984_2153269.jpg',
      '/assets/uploads_1_2_8_8_12888984_5216949.jpg',
      '/assets/uploads_1_2_8_8_12888984_2687410.jpg',
      '/assets/uploads_1_2_8_8_12888984_2623859.jpg',
      '/assets/uploads_1_2_8_8_12888984_2252317.jpg',
      '/assets/uploads_1_2_8_8_12888984_8858696.jpg',
      '/assets/uploads_1_2_8_8_12888984_4315832.jpg',
    ],
  },
]

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null)
  const close = useCallback(() => setLightbox(null), [])

  return (
    <>
      {GALLERIES.map((gallery, gi) => (
        <div key={gi} className="gallery-section">
          <h2>{gallery.title}</h2>
          <p className="desc">{gallery.description}</p>
          <div className={`gallery-grid cols-${gallery.cols}`}>
            {gallery.images.map((src, i) => (
              <div
                key={i}
                className="gallery-thumb"
                onClick={() => setLightbox(src)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setLightbox(src)}
                aria-label="View full size"
              >
                <img src={src} alt="" loading="lazy" />
              </div>
            ))}
          </div>
          {gi < GALLERIES.length - 1 && (
            <hr className="section-divider" style={{ marginTop: 20 }} />
          )}
        </div>
      ))}

      {lightbox && <Lightbox src={lightbox} onClose={close} />}
    </>
  )
}
